// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card-title {
  font-weight: bold;
  color: var(--text-color);
}

h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}

img {
  width: 100%;
  padding: 1rem 0.5rem;
  display: block;
  margin: 0 auto;
  color: var(--text-color);
}

mat-card-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
mat-card-actions a {
  width: 100%;
  color: var(--text-color);
}
mat-card-actions button {
  margin: 0.5rem 0 0;
  width: 100%;
  background-color: var(--background);
  color: var(--text-color);
}

mat-card-content {
  background-color: var(--background);
}
mat-card-content p {
  line-height: 1.2em;
  position: relative;
  height: 5.8em;
  text-align: justify;
  overflow: hidden;
  color: var(--text-color);
}
mat-card-content p:after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 70%;
  height: 1.2em;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), var(--background) 50%);
}

mat-card {
  background-color: var(--background);
}

@media only screen and (min-width: 960px) {
  .fxFlex-33-50sm-100xs {
    flex: 1 1 33%;
    max-width: 33%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) and (min-width: 600px) {
  .fxFlex-33-50sm-100xs {
    flex: 1 1 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 599px) {
  .fxFlex-33-50sm-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/home.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,wBAAA;AACJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,mCAAA;EACA,wBAAA;AAAJ;;AAIA;EAEE,mCAAA;AAFF;AAIE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;AAFJ;AAKI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,oFAAA;AAHN;;AAUA;EACE,mCAAA;AAPF;;AAcA;EACE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EAZF;AACF;AAkBA;EAEE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EAlBF;AACF;AAwBA;EAEE;IAEE,cAAA;IACA,eAAA;IACA,sBAAA;EAxBF;AACF","sourcesContent":["mat-card-title {\r\n  font-weight: bold;\r\n  color: var(--text-color);\r\n}\r\n\r\nh1 {\r\n  font-size: 250%;\r\n  text-align: center;\r\n  color: var(--text-color);\r\n}\r\n\r\nimg {\r\n  width: 100%;\r\n  padding: 1rem 0.5rem;\r\n  display: block;\r\n  margin: 0 auto;\r\n  color: var(--text-color);\r\n}\r\n\r\nmat-card-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n\r\n  a {\r\n    width: 100%;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  button {\r\n    margin: 0.5rem 0 0;\r\n    width: 100%;\r\n    background-color: var(--background);\r\n    color: var(--text-color);\r\n  }\r\n}\r\n\r\nmat-card-content {\r\n\r\n  background-color: var(--background);\r\n\r\n  p {\r\n    line-height: 1.2em;\r\n    position: relative;\r\n    height: 5.8em;\r\n    text-align: justify;\r\n    overflow: hidden;\r\n    color: var(--text-color);\r\n\r\n\r\n    &:after {\r\n      content: \"\";\r\n      text-align: right;\r\n      position: absolute;\r\n      bottom: 0;\r\n      right: 0;\r\n      width: 70%;\r\n      height: 1.2em;\r\n      background: linear-gradient(to right,\r\n          rgba(255, 255, 255, 0),\r\n          var(--background) 50%);\r\n    }\r\n  }\r\n}\r\n\r\nmat-card {\r\n  background-color: var(--background);\r\n\r\n}\r\n\r\n\r\n\r\n// Media query za site uredi pogolemi od 960px (md, lg i xl uredi)\r\n@media only screen and (min-width: 960px) {\r\n  .fxFlex-33-50sm-100xs {\r\n\r\n    flex: 1 1 33%;\r\n    max-width: 33%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 960px i pogolemi od 600px (sm uredi)\r\n@media only screen and (max-width: 959px) and (min-width:600px) {\r\n  \r\n  .fxFlex-33-50sm-100xs {\r\n\r\n    flex: 1 1 50%;\r\n    max-width: 50%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 600px (xs uredi)\r\n@media only screen and (max-width: 599px) {\r\n  \r\n  .fxFlex-33-50sm-100xs {\r\n\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
